/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Priority_None_OptionInputs */



/**
* | output |
* | --- |
* | "None" |
*
* @param {Explorer_Info_Priority_None_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_priority_none_option = /** @type {((inputs?: Explorer_Info_Priority_None_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Priority_None_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("None")
	if (locale === "de") return /** @type {LocalizedString} */ ("None")
	if (locale === "it") return /** @type {LocalizedString} */ ("None")
	if (locale === "ru") return /** @type {LocalizedString} */ ("None")
	if (locale === "es") return /** @type {LocalizedString} */ ("None")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("None")
	if (locale === "ja") return /** @type {LocalizedString} */ ("None")
	if (locale === "hi") return /** @type {LocalizedString} */ ("None")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("None")
	return /** @type {LocalizedString} */ ("None")
});